import { render, staticRenderFns } from "./proceedingsWorkingPlan.vue?vue&type=template&id=9b2632c4"
import script from "./proceedingsWorkingPlan.vue?vue&type=script&lang=js"
export * from "./proceedingsWorkingPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b2632c4')) {
      api.createRecord('9b2632c4', component.options)
    } else {
      api.reload('9b2632c4', component.options)
    }
    module.hot.accept("./proceedingsWorkingPlan.vue?vue&type=template&id=9b2632c4", function () {
      api.rerender('9b2632c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsWorkingPlan.vue"
export default component.exports